import { useEffect } from 'react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { useThemeManager } from '@/hooks/useTheme';
import { globalServiceManager } from '@/services/reading/serviceManager';

interface AppInitializerProps {
  children: React.ReactNode;
}

// 应用初始化组件，负责设置全局状态和监听器
const AppInitializer: React.FC<AppInitializerProps> = ({ children }) => {
  // 初始化网络状态监听
  useNetworkStatus();
  
  // 初始化主题管理
  useThemeManager();

  useEffect(() => {
    // 应用启动时的初始化逻辑
    const initializeApp = async () => {
      try {
        console.log('Dopamine Web App initializing...');
        
        // 初始化阅读服务
        await globalServiceManager.initialize();
        console.log('Reading services initialized successfully');
        
        console.log('Dopamine Web App initialized with enhanced routing');
      } catch (error) {
        console.error('Failed to initialize app:', error);
      }
    };

    initializeApp();
    
    // 清理函数
    return () => {
      globalServiceManager.cleanup();
    };
  }, []);

  return <>{children}</>;
};

export default AppInitializer;